import React, { memo } from 'react';
import { useTableContext } from '../../context/TableContext';
import TagsDropdown from '../../../FlowchartView/TaskNode/TagsDropdown';

/**
 * Tags cell - uses shared TagsDropdown component from Flow/Kanban views
 * This ensures consistent styling and functionality across all views
 * Memoized to prevent re-renders when other cells change
 */
const TagsCell = memo(({ row }) => {
  const { 
    allTags, 
    onAddTag,
    onRemoveTag,
    onSetPrimaryTag,
    onRenameTag,
    onDeleteTag,
  } = useTableContext();
  const task = row.original;

  return (
    <div className="table-view__tags-cell">
      <TagsDropdown
        taskId={task.id}
        task={task}
        allTags={allTags}
        onAddTag={onAddTag}
        onRemoveTag={onRemoveTag}
        onSetPrimaryTag={onSetPrimaryTag}
        onRenameTag={onRenameTag}
        onDeleteTag={onDeleteTag}
      />
    </div>
  );
}, (prevProps, nextProps) => {
  const prevTask = prevProps.row.original;
  const nextTask = nextProps.row.original;
  // Re-render if task id, tags array, or category (for backwards compat) changes
  return prevTask.id === nextTask.id && 
         JSON.stringify(prevTask.tags) === JSON.stringify(nextTask.tags) &&
         prevTask.category === nextTask.category;
});

export default TagsCell;
